<template>
  <i-dropdown v-if="hasMultipleOptions">
    <template v-slot:trigger="{toggle, isOpen, attrs}">
      <button class="i-button btn i-simple-btn flex" v-bind="attrs" @click="toggle">
        <i-icon aria-hidden="true"
          :title="selectedMode.label"
          :icon="selectedMode.icon"
          class="fa5"></i-icon>
        <span class="sr-only">{{selectedMode.label}}</span>
        <span class="i-secondary-wf-dropdown-label">{{selectedMode.label}}</span>
        <i-icon :icon="isOpen ? 'caret-up' : 'caret-down'" style="padding: 0 5px; "></i-icon>
      </button>
    </template>
    <template v-slot:default="{close}">
      <ul class="dropdown-menu i-dropdown-menu block" role="menu">
        <span class="pl2">{{ LANG.browseBy }}</span>
        <li
          v-for="{mode, label, icon, enabled} in modes"
          class="dropdown-item"
          :class="{'i-dropdown-item-selected': mode === treeMode}"
          :aria-label="label"
          :key="mode">
            <a
              href="#"
              class="i-action-browse-by"
              :class="{ 'i-state-disabled': !enabled }"
              :title="label"
              @click.prevent="() => { fetchTree(mode); close(); }">
              <i aria-hidden="true"
                class="fa5 fas"
                :class="`fa-${icon}`"
                :name="icon"></i>
              {{label}}
          </a>
        </li>
      </ul>
    </template>
  </i-dropdown>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mapBrowserState, mapBrowserActions } from '@/store';
import { TreeMode } from '@/store/modules/entity_browser/config';

export default {
  computed: {
    ...mapState(['LANG']),
    ...mapGetters(['checkACL']),
    ...mapBrowserState(['treeMode']),
    selectedMode() {
      return this.modes.find((m) => m.mode === this.treeMode) || {};
    },
    modes() {
      return [
        {
          mode: TreeMode.CATEGORY,
          label: this.LANG.categories,
          icon: 'folder-tree',
          enabled: this.checkACL('/data/categories'),
        },
        {
          mode: TreeMode.DIRECTORY,
          label: this.LANG.directories,
          icon: 'hdd',
          enabled: this.checkACL('/data/directories'),
        },
      ];
    },
    // only show the toggle if there are mutliple options (more than 1 tree mode)
    hasMultipleOptions() {
      return this.modes.filter((m) => Boolean(m.enabled)).length > 1;
    },
  },
  methods: {
    ...mapBrowserActions(['fetchTree']),
  },
};
</script>
